"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvmChainResolver = void 0;
var evm_utils_1 = require("@moralisweb3/evm-utils");
var EvmApiConfig_1 = require("../config/EvmApiConfig");
var EvmChainResolver = /** @class */ (function () {
    function EvmChainResolver() {
    }
    EvmChainResolver.resolve = function (chain, core) {
        if (chain) {
            return evm_utils_1.EvmChain.create(chain, core);
        }
        var defaultEvmChain = core.config.get(EvmApiConfig_1.EvmApiConfig.defaultEvmApiChain);
        return evm_utils_1.EvmChain.create(defaultEvmChain, core);
    };
    return EvmChainResolver;
}());
exports.EvmChainResolver = EvmChainResolver;
//# sourceMappingURL=EvmChainResolver.js.map